module.exports = __webpack_public_path__ + "img/updateicon.5e06cfa5.svg";